export enum CoreClientPhotoApiTags {
  ClientPhotoList = 'ClientPhotoList',
}

export const coreClientPhotoApiTags = Object.values(CoreClientPhotoApiTags);
